import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { searchProducts } from '../redux/user/shop/shop_service_syn';
import { getSingleBrand } from '../redux/user/brands/brands_service_syn';
import { FaEye, FaHeart, FaShoppingCart } from 'react-icons/fa';
import { InfinitySpin } from 'react-loader-spinner';
import { updateCartIndicator } from '../redux/user/cart/cartSlices';
import {
  UserMajorCartCreation,
  UserGetCart,
} from '../redux/user/cart/cartServicesSync';
import { updateWishListIndicator } from '../redux/user/wish_list/wish_list_slices';
import {
  UserGetWishList,
  UserMajorWishListCreation,
} from '../redux/user/wish_list/wish_list_services_sync';
import LoaderScreen from '../component/loader/loaderScreen';
import EmptyState from '../component/EmptyState';
import PaginationComponent from '../component/pagination/PaginationComponent';

const BrandPage = () => {
  const { brandId } = useParams();
  const location = useLocation();
  const brandName = location.state?.brandName || brandId || 'Brand';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  const { products, loading, cartIndicator, wish_list } = useSelector((state) => ({
    products: state.shop.products,
    loading: state.shop.loading || state.landpage.loading,
    cartIndicator: state.user_cart.cartIndicator,
    wish_list: state.user_wish_list.wish_list,
  }));

  const { singleBrand, singleBrandLoading } = useSelector(
    (state) => state.brands
  );

  const totalPages = products?.totalPages || 1;
  const limit = products?.limit || 10;

  useEffect(() => {
    console.log('Brand ID from params:', brandId);
    if (brandId && !isNaN(brandId)) {
      dispatch(getSingleBrand({ Id: brandId }));
    }

    fetchProductsByPage(currentPage);


    dispatch(UserGetCart());
    dispatch(UserGetWishList());
  }, [dispatch, brandId, brandName, currentPage]);


  const fetchProductsByPage = (page) => {
    dispatch(
      searchProducts({
        name: '""',
        category: '""',
        brand: brandName,
        from: 0,
        to: 0,
        page: page,
        limit: 10,
      })
    ).then((response) => {
      console.log('Products response:', response);
    });
  };

  useEffect(() => {
    if (singleBrand && singleBrand.name && !brandName) {
      fetchProductsByPage(currentPage);
    }
  }, [dispatch, singleBrand, brandName]);

  const handleMouseEnter = (itemId) => {
    setHoveredItem(itemId);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const handleAddToCart = (item) => {
    dispatch(updateCartIndicator(item._id));

    dispatch(
      UserMajorCartCreation({
        productId: item._id,
        quantity: 1,
      })
    )
      .then(() => {
        dispatch(UserGetCart());
        dispatch(updateCartIndicator(''));
      })
      .catch(() => {
        dispatch(updateCartIndicator(''));
      });
  };

  const handleViewProduct = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handleAddToWishlist = (item) => {
    dispatch(updateWishListIndicator(item._id));

    dispatch(
      UserMajorWishListCreation({
        productId: item._id,
        quantity: 1,
        price: item.price,
      })
    )
      .then(() => {
        dispatch(UserGetWishList());
        dispatch(updateWishListIndicator(''));
      })
      .catch(() => {
        dispatch(updateWishListIndicator(''));
      });
  };

  const isInWishlist = (itemId) => {
    return wish_list?.products?.some((item) => item.product === itemId);
  };

  const handlePageChange = (page) => {
    // Convert to 0-based indexing if your API expects it that way
    const apiPage = page - 1;

    // Update local state
    setCurrentPage(apiPage);

    // Fetch products for the new page
    dispatch(
      searchProducts({
        name: '""',
        category: '""',
        brand: brandName,
        from: 0,
        to: 0,
        page: apiPage,
        limit: 10,
      })
    );
  };


  if (loading || singleBrandLoading) {
    return (
      <section className="product__section section--padding pt-0">
        <div className="container-fluid">
          <div className="d-flex justify-content-center min-h-[50vh] items-center">
            <LoaderScreen />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="product__section section--padding pt-0">
      <div className="container-fluid">
        <div className="mx-auto px-4 py-12">
          <div className="text-center mb-12">
            {singleBrand?.brand_image && (
              <img
                src={singleBrand.brand_image}
                alt={singleBrand.name || brandName}
                className="mx-auto mb-4"
                style={{ maxHeight: '100px', objectFit: 'contain' }}
              />
            )}
            <h1 className="text-3xl font-bold">
              {singleBrand?.name || brandName} Products
            </h1>
            {singleBrand?.description && (
              <p className="mt-4 text-gray-600">{singleBrand.description}</p>
            )}
          </div>

          <div className="store-product-grid store-product-grid--catalog">
            {products?.docs?.length > 0 ? (
              products?.docs?.map((item) => (
                <div
                  key={item._id}
                  className="store-catalog-card group relative bg-white rounded-lg overflow-hidden flex flex-col h-full"
                  onMouseEnter={() => handleMouseEnter(item._id)}
                  onMouseLeave={handleMouseLeave}
                >
                  {typeof item.tags === 'string' &&
                    item.tags.toLowerCase().includes('new') && (
                      <div className="absolute top-4 left-4 bg-red-500 text-white text-sm px-2 py-1 rounded-md z-10">
                        New
                      </div>
                    )}

                  {/* Image */}
                  <div className="store-card-image overflow-hidden">
                    <img
                      src={
                        item.gallery?.[hoveredItem === item._id ? 1 : 0]
                          ?.pic_url
                      }
                      alt={item.product_name}
                      width={300}
                      height={300}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>

                  {/* Quick actions */}
                  <div className="store-card-actions">
                    <button
                      className="p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
                      onClick={() => handleViewProduct(item._id)}
                    >
                      <FaEye className="w-5 h-5" />
                    </button>
                    <button
                      className="p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
                      onClick={() => handleAddToWishlist(item)}
                    >
                      <FaHeart
                        className={`w-5 h-5 ${isInWishlist(item._id) ? 'text-red-500' : 'text-gray-400'
                          }`}
                      />
                    </button>
                  </div>

                  {/* Content */}
                  <div className="store-card-content flex-grow">
                    <h3 className="font-semibold text-[2rem] leading-8 mb-2 min-h-[4rem]">
                      {item.product_name}
                    </h3>
                    <div className="flex items-center gap-2">
                      <span className="text-red-500 text-xl font-bold">
                        {item.symbol}
                        {item.price}
                      </span>
                      {item.discount && (
                        <span className="text-gray-400 line-through text-lg">
                          {item.symbol}
                          {item.discount}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Add to cart */}
                  <div>
                    {item._id === cartIndicator ? (
                      <button className="w-full bg-red-500 text-white py-[0.35rem] flex items-center justify-center gap-2 mt-auto">
                        <InfinitySpin width="80" color="#FFFFFF" />
                      </button>
                    ) : (
                      <button
                        onClick={() => handleAddToCart(item)}
                        className="w-full bg-red-500 text-white py-[0.35rem] flex items-center justify-center gap-2 mt-auto"
                      >
                        <FaShoppingCart className="w-5 h-5" />
                        Add to cart
                      </button>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full">
                <EmptyState
                  message={`No products found for ${
                    singleBrand?.name || brandName
                  }`}
                />
              </div>
            )}
          </div>

          {/* Pagination */}
          {products?.docs?.length > 0 && totalPages > 1 && (
            <div className="mt-12">
              <PaginationComponent
                currentPage={products?.page || 1}
                totalItems={products?.totalDocs || 0}
                pageSize={limit}
                handlePageChange={handlePageChange}
              />
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default BrandPage;
